export default "__VITE_ASSET__4b3ea28f__"